/**
 * For removing duplicate items from an array
 * Guarantees the original order of all non-duplicated items
 * Usage: [1, 2, 1].filter(onlyUnique)
 */
export function onlyUnique<T>(value : T , index : number, self : T[]) {
	return Array.prototype.indexOf.call(self, value) === index;
}

/**
 * Uniquifies an entire array, with no guarantees as to ordering
 * @param arr the array to make unique
 */
let unique = function<T>(arr : T[]) : T[] {
	return arr.filter(onlyUnique);
};

// Fast-path version for modern browsers
if('Set' in window && 'from' in Array && (new Set([1])).size) {
	// IE 11 supports set and Array.from but not initializing a set with a pre-existing array.
	unique = function(arr) {
		return Array.from(new Set(arr));
	};
}

export { unique };

export function flatten<T>(arr : T[][]) : T[] {
	return ([] as T[]).concat(...arr);
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/array.ts